import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";

const HrMovement = React.lazy(() => import("@/pages/movement/hr/HrMovement"));

const Index = [
    {
        path: "hrMovement",
        element: (
            <SuspenseWrapper>
                <HrMovement />
            </SuspenseWrapper>
        ),
    },
];

export default Index;
